/** @jsx jsx */
import { Box, EmptyState, EmptyStateListWhite } from "@eworkit/iris";
import { FC } from "react";
import { useTranslation } from "react-i18next";
import { jsx } from "theme-ui";

import { LifecycleList } from "@/components/lifecycle";
import { useJobApplicationLifecycleQuery } from "@/data/job-applications/queries/useJobApplicationLifecycleQuery";
import { JobApplication } from "@/data/job-applications/types/JobApplication";

interface JobApplicationDetailsLifecycleTabProps {
  jobApplication: JobApplication;
}

export const JobApplicationDetailsLifecycleTab: FC<JobApplicationDetailsLifecycleTabProps> = ({ jobApplication }) => {
  const { data } = useJobApplicationLifecycleQuery(jobApplication.id);
  const { t } = useTranslation("session");

  return data.totalElements > 0 ? (
    <LifecycleList actions={data.content} />
  ) : (
    <Box sx={{ py: 120 }} px="sm">
      <EmptyState
        icon={<EmptyStateListWhite />}
        title={t("JOB_APPLICATIONS.DETAIL.LIFECYCLE.NO_ACTIONS")}
        content={t("JOB_APPLICATIONS.DETAIL.LIFECYCLE.NO_ACTIONS_DESCRIPTION")}
      />
    </Box>
  );
};
